/* eslint-disable */
// Do not edit this generated file.  If this file needs changes then the createThemeImporterAndLoader script should be modified
// This file is generated by the createThemeLoader script when the createThemes, or createTheme script is run
// Custom styling can be added to the theme loader.  The object returned by the theme loader is merged with the MUI Theme object.
import * as tokens from "./themeTokensEs6";
import { tokenList } from "./themeTokenMap";
const InterstateThemeLoader = {
  tokens: {
    ...tokens
  },
  tokenMap: new Map(tokenList)
};
export default InterstateThemeLoader;